import React from 'react'
import OrganisationMetrics from '../../components/organisation-metrics'

const OrganisationMetricsPage = () => {
  return <OrganisationMetrics />
}

export default OrganisationMetricsPage
